export const defaultGameInfo = {
  user_name: "",
  user_id: "",
  currency: "USD",
  balance: "",
  toFix: 2,
  maxBet: "",
  minBet: "",
  game_settings: null,
  serverSeedSHA256: "",
  clientSeed: "",
  nonce: 0,
  next_server_seed_SHA256: "",
}

export const defaultSeeds = {
  client_seed: "",
  server_seed_SHA256: "",
  next_server_seed_SHA256: "",
  nonce: 0,
  old_client_seed: "",
  old_server_seed: "",
  old_server_seed_SHA256: "",
  old_nonce: 0,
}

export const defaultStakes = {
  stake: "0",
  numOfBets: "0",
  cashoutAt: "0",
}
export const defaultAudio = {
  music: true,
  sound: true,
  volume: "0.5",
}
export const defaultPlaceBet = {
  balance: "",
  bet: "",
  currency: "",
  state: "",
  error: {
    code: 0,
    status: "",
    message: "",
  },
  index: "",
}
export const defaultSettings = {
  stake: "0.00",
  audio: {
    music: true,
    sound: true,
    volume: "0.5",
  },
  numOfBets: "",
  cashoutAt: "",
}
